import {createLazyLoadTrigger} from "@/laraberg_frontend/general"

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPackageDetails)
} else {
    initPackageDetails()
}

async function initPackageDetails() {
    setTimeout(async () => {
        const [
            {createApp},
            {buttonFavIconPackage, buttonFavIconPackageNotLogin},
            {checkUseContent},
            {scrollToSmoothly},
            ContentActions,
            ContentActionsButtons,
            ImageTwentyTwenty,
            ImageView,
            DownloadInfo,
            UserInterest,
            Comments,
            CreditsPopup,
            PackageButtons,
            ContentButtons,
            ProgressCircle,
            PackageActionsButtons
        ] = await Promise.all([
            import("vue"),
            import("@/libs/buttonEvents.ts"),
            import("@/libs/eventBus.ts"),
            import("@/libs/helpers.ts"),
            import("@/components/Frontend/ContentActions.vue"),
            import("@/components/Frontend/ContentActionsButtons.vue"),
            import("@/components/Frontend/ImageTwentyTwenty.vue"),
            import("@/components/Frontend/ImageView.vue"),
            import("@/components/Frontend/DownloadInfo.vue"),
            import("@/components/Frontend/UserInterest.vue"),
            import("@/components/Frontend/BaseComments.vue"),
            import("@/components/Frontend/CreditsPopup.vue"),
            import("@/components/Frontend/PackageButtons.vue"),
            import("@/components/Frontend/ContentButtons.vue"),
            import("@/components/Frontend/ProgressCircle.vue"),
            import("@/components/Frontend/PackageActionsButtons.vue")
        ])

        buttonFavIconPackage()
        buttonFavIconPackageNotLogin()

        // HEADER
        const PackageHeaderApp = createApp({})
        const PackageHeaderComponents = {
            "package-actions-buttons": PackageActionsButtons.default,
            "package-buttons": PackageButtons.default,
            "content-buttons": ContentButtons.default,
            "progress-circle": ProgressCircle.default
        }
        Object.entries(PackageHeaderComponents).forEach(([name, component]) => {
            PackageHeaderApp.component(name, component)
        })
        PackageHeaderApp.mount("#package-header")

        // DETAILS
        const PackageDetailsApp = createApp({})
        const PackageDetailsComponents = {
            "image-twenty-twenty": ImageTwentyTwenty.default,
            "base-comments": Comments.default,
            //"credits-popup": CreditsPopup.default,
            "package-buttons": PackageButtons.default,
            "content-buttons": ContentButtons.default,
            "progress-circle": ProgressCircle.default
        }
        Object.entries(PackageDetailsComponents).forEach(([name, component]) => {
            PackageDetailsApp.component(name, component)
        })
        PackageDetailsApp.mount("#package-details")

        // IMAGE VIEW
        const PackageImageViewApp = createApp({})
        const PackageImageViewComponents = {
            "image-view": ImageView.default
        }
        Object.entries(PackageImageViewComponents).forEach(([name, component]) => {
            PackageImageViewApp.component(name, component)
        })
        PackageImageViewApp.mount("#package-image-view")

        // COMMENTS
        const PackageCommentsApp = createApp({})
        const PackageCommentsComponents = {
            "base-comments": Comments.default
        }
        Object.entries(PackageCommentsComponents).forEach(([name, component]) => {
            PackageCommentsApp.component(name, component)
        })
        PackageCommentsApp.mount("#package-comments")

        // DOWNLOAD INFO
        const PackageDownloadInfoApp = createApp({})
        const PackageDownloadInfoComponents = {
            "download-info": DownloadInfo.default
        }
        Object.entries(PackageDownloadInfoComponents).forEach(([name, component]) => {
            PackageDownloadInfoApp.component(name, component)
        })
        PackageDownloadInfoApp.mount("#download-info")

        handleHashNavigation()

        initializeImageGallery()
        initializeExpandableAreas()
        initializeCommentsLink(scrollToSmoothly)

        createLazyLoadTrigger("#package-details-footer", 200, async () => {
            const PackageDetailsFooterApp = createApp({})
            const PackageDetailsFooterComponents = {
                // "package-actions-buttons": PackageActionsButtons.default,
                "content-actions": ContentActions.default,
                "content-actions-buttons": ContentActionsButtons.default,
                "download-info": DownloadInfo.default,
                "user-interest": UserInterest.default,
                "base-comments": Comments.default,
                "credits-popup": CreditsPopup.default,
                // "package-buttons": PackageButtons.default,
                "content-buttons": ContentButtons.default
                // "progress-circle": ProgressCircle.default
            }
            Object.entries(PackageDetailsFooterComponents).forEach(([name, component]) => {
                PackageDetailsFooterApp.component(name, component)
            })

            PackageDetailsFooterApp.mount("#package-details-footer")

            initializeVideoInteractions(checkUseContent)
            initializeContentPreview()
        })
    }, 600)

    function handleHashNavigation() {
        if (window.location.hash && window.location.hash !== "#anchor-package-content") {
            const urlProductId = window.location.hash
            const productElem = document.querySelector(urlProductId)
            const parentOfProductElem = productElem?.closest(".expandable-area")
            if (parentOfProductElem && !parentOfProductElem.classList.contains("expanded")) {
                parentOfProductElem.classList.add("expanded")
            }
        }

        if (/^#content-\d+$/.test(window.location.hash)) {
            const packageChapterExpandableArea = document.querySelector(".package-chapter .expandable-area")
            packageChapterExpandableArea?.classList.add("expanded")
            setTimeout(() => {
                const element = document.getElementById(window.location.hash.substring(1))
                element?.scrollIntoView({behavior: "smooth", block: "center"})
            }, 50)
        }
    }

    function initializeImageGallery() {
        const exampleImages = document.querySelectorAll(".example-images .swiper-slide")
        const exampleImageSources = Array.from(exampleImages)
            .map((element) => {
                const galleryImage = {}
                const card = element.querySelector(".card[data-image-view-event]")
                const twentytwentyContainer = card?.querySelector(".twentytwenty-container")
                if (twentytwentyContainer) {
                    const images = twentytwentyContainer.querySelectorAll("img")
                    galleryImage.imageBefore = images[1]?.src
                    galleryImage.imageAfter = images[0]?.src
                } else if (card) {
                    galleryImage.single = card.dataset.imageViewEvent
                } else {
                    return false
                }

                galleryImage.caption = (
                    element.querySelector(".card-text") || element.querySelector(".card-body")
                )?.innerText
                return galleryImage
            })
            .filter(Boolean)

        const handleImageGallery = (event, element) => {
            if (!event.target.classList.contains("twentytwenty-handle")) {
                const currentGalleryIndex = exampleImageSources.findIndex(
                    (image) =>
                        (image.single &&
                            image.single.replace(/\.[^.]+$/, "") ===
                            element.dataset.imageViewEvent.replace(/\.[^.]+$/, "")) ||
                        (image.imageBefore &&
                            image.imageBefore.replace(/\.[^.]+$/, "") ===
                            element.dataset.imageViewEvent.replace(/\.[^.]+$/, ""))
                )

                window.eventBus.$emit("imageGallery", {
                    imageGallery: exampleImageSources,
                    currentGalleryIndex
                })
            }
        }

        const cardImageViewEvent = document.querySelectorAll(".card[data-image-view-event]")
        cardImageViewEvent.forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault()
                handleImageGallery(event, element)
            })

            element.addEventListener("touch", (event) => {
                event.preventDefault()
                handleImageGallery(event, element)
            })
        })
    }

    function initializeExpandableAreas() {
        const expandableAreas = document.querySelectorAll(".expandable-area-toggle")
        expandableAreas.forEach((toggle) => {
            toggle.addEventListener("click", () => {
                const expandableArea = toggle.closest(".expandable-area")
                if (expandableArea) {
                    expandableArea.classList.toggle("expanded")
                }
            })
        })
    }

    function initializeCommentsLink(scrollToSmoothly) {
        const packageCommentsLink = document.querySelectorAll(".package-comments-link")
        packageCommentsLink.forEach((link) => {
            link.addEventListener(
                "click",
                () => {
                    const commentsBlock = document.querySelector("#package-comments")
                    commentsBlock.classList.add("expanded")
                    scrollToSmoothly(commentsBlock.offsetTop - 20, 800)
                },
                {passive: true}
            )
        })
    }

    function initializeVideoInteractions(checkUseContent) {
        const videoPlayButtons = document.querySelectorAll(".video-play-button, .video-play-title, .content-title-video")
        const $iFrame = document.getElementById("iframe-video")
        const $iFrameContainer = document.getElementById("container-iframe-video")
        const $body = document.querySelector("body")

        const helpVideoStatistics = async (id) => {
            const protocol = window.location.href.startsWith("https://") ? "https://" : "http://"
            const csrfToken = document.querySelector("meta[name=csrf-token]").content
            const data = {id}
            const response = await fetch(`${protocol}${window.location.host}/statistics/view-accompanying-video`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "X-CSRF-TOKEN": csrfToken
                },
                body: JSON.stringify(data)
            })
            return response.json()
        }

        const VideoPlay = (playButton) => {
            const dataHref = playButton.dataset.href
            const videoHref = playButton.getAttribute("video-href")
            const dataVideoUrl = playButton.dataset.videoUrl

            const clickHandler = async (event) => {
                event.preventDefault()
                let canUse = false

                if (videoHref) {
                    const matchesId = videoHref.match(/\d+$/)
                    if (matchesId) {
                        canUse = await checkUseContent(matchesId[0])
                    }
                    if (canUse) {
                        $iFrame.src = videoHref
                        $iFrameContainer.style.display = "block"
                        $body.style.overflowY = "hidden"
                    }
                    helpVideoStatistics(playButton.dataset.id)
                } else if (dataVideoUrl) {
                    const matchesId = dataVideoUrl.match(/\d+$/)
                    if (matchesId) {
                        canUse = await checkUseContent(matchesId[0])
                    }
                    if (canUse) {
                        $iFrame.src = dataVideoUrl
                        $iFrameContainer.style.display = "block"
                        $body.style.overflowY = "hidden"
                    }
                    helpVideoStatistics(playButton.dataset.id)
                } else if (dataHref) {
                    window.eventBus.$emit("exampleVideo", dataHref)
                }
            }

            playButton.addEventListener("click", clickHandler, {passive: !videoHref && !dataVideoUrl})
        }

        videoPlayButtons.forEach((button) => VideoPlay(button))

        const $iconCloseVideo = document.querySelector("#icon-close-video")
        if ($iconCloseVideo) {
            $iconCloseVideo.addEventListener(
                "click",
                (event) => {
                    event.stopPropagation()
                    $body.style.overflowY = "auto"
                    $iFrameContainer.style.display = "none"
                    $iFrame.src = ""
                    if (window.location.hash) {
                        localStorage.setItem("scroll_to_content", window.location.hash)
                        window.location.href = window.location.href.split("#")[0]
                    } else {
                        document.location.reload()
                    }
                },
                {passive: true}
            )
        }

        document.addEventListener(
            "keydown",
            (evt) => {
                evt = evt || window.event
                if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
                    if ($iFrameContainer.style.display === "block") {
                        evt.stopPropagation()
                        $body.style.overflowY = "auto"
                        $iFrameContainer.style.display = "none"
                        $iFrame.src = ""
                    }
                }
            },
            {passive: true}
        )
    }

    function initializeContentPreview() {
        const videoPreviewImages = document.querySelectorAll(".video-content-teaser-preview")
        videoPreviewImages.forEach((el) => {
            el.addEventListener("mouseenter", videoPreviewImageShow, {passive: true})
            el.addEventListener("mouseleave", videoPreviewImageHide, {passive: true})
        })

        function videoPreviewImageShow(e) {
            const popupVideoPreview = e.target.nextElementSibling
            if (popupVideoPreview) {
                popupVideoPreview.classList.add("visible")
                const imageElement = popupVideoPreview.querySelector("img")
                if (imageElement && !imageElement.getAttribute("src")) {
                    imageElement.setAttribute("src", imageElement.dataset.src)
                }
            }

            const cursorX = e.clientX
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if (cursorX < screenWidth / 2) {
                popupVideoPreview.classList.add("left")
            } else {
                popupVideoPreview.classList.add("right")
            }
        }

        function videoPreviewImageHide(e) {
            const popupVideoPreview = e.target.nextElementSibling
            if (popupVideoPreview) {
                popupVideoPreview.classList.remove("visible")
                popupVideoPreview.classList.remove("left")
                popupVideoPreview.classList.remove("right")
            }
        }
    }
}
